import { Tool } from 'approot/activity-builder/components/draw/canvas/draw-canvas.constants';
import IconCursorArrow from 'approot/shared/icons/icon-cursor-arrow';
import IconCursorCrosshair from 'approot/shared/icons/icon-cursor-crosshair';
import IconCursorHand from 'approot/shared/icons/icon-cursor-hand';
import IconCursorHandClosed from 'approot/shared/icons/icon-cursor-hand-closed';
import IconCursorText from 'approot/shared/icons/icon-cursor-text';
import IconCursorEraserDark from 'approot/shared/icons/icon-cursor-eraser-dark';
import IconCursorPencilDark from 'approot/shared/icons/icon-cursor-pencil-dark';
import IconRedo from 'approot/shared/inline-svg/activity-builder/icon-redo';

const CustomCursor = ({
  isCursorClosed,
  tool,
  rotateCursor,
}: {
  isCursorClosed: boolean;
  tool: Tool | undefined;
  rotateCursor: boolean;
}) => {
  if (rotateCursor) {
    return <IconRedo width={18} height={18} />;
  }

  if (tool === Tool.Pencil) {
    return <IconCursorPencilDark width={18} height={18} />;
  }

  if (tool === Tool.Eraser) {
    return <IconCursorEraserDark width={18} height={18} />;
  }

  if (tool === Tool.Text) {
    return <IconCursorText width={18} height={18} />;
  }

  if (tool === Tool.Shapes) {
    return <IconCursorCrosshair width={18} height={18} />;
  }

  if (tool === Tool.Select) {
    return <IconCursorArrow width={18} height={18} />;
  }

  if (tool === Tool.Cursor) {
    return isCursorClosed ? (
      <IconCursorHandClosed width={18} height={18} />
    ) : (
      <IconCursorHand width={18} height={18} />
    );
  }

  return <IconCursorArrow width={18} height={18} />;
};

export default CustomCursor;
